import { useSyncExternalStore } from "react"

interface UseVoiceManagerReturn {
  allVoices: string[]
  voiceCount: number
}

const EMPTY: string[] = []

const cache = { fingerprint: "", languages: EMPTY }

export function useVoiceManager(): UseVoiceManagerReturn {
  const allVoices = useSyncExternalStore(
    subscribe,
    getSnapshot,
    getServerSnapshot,
  )
  return { allVoices, voiceCount: allVoices.length }
}

function getServerSnapshot(): string[] {
  return EMPTY
}

function getSnapshot(): string[] {
  if (typeof window === "undefined" || !window.speechSynthesis) {
    return EMPTY
  }
  const voices = window.speechSynthesis.getVoices()
  const fingerprint = voices.map(v=> v.lang).join("|")
  if (fingerprint !== cache.fingerprint) {
    cache.fingerprint = fingerprint
    cache.languages = voices.map(v=> v.lang)
  }
  return cache.languages
}

function subscribe(onChange: ()=> void) {
  if (typeof window === "undefined" || !window.speechSynthesis) {
    return ()=> {}
  }
  const synth = window.speechSynthesis
  synth.addEventListener("voiceschanged", onChange)
  return ()=> synth.removeEventListener("voiceschanged", onChange)
}
